module.exports = __webpack_public_path__ + "static/media/twitter-logo.32e1a625.svg";